/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Kredi_SistemiInputs */

const tr_faq_a_kredi_sistemi = /** @type {(inputs: Faq_A_Kredi_SistemiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay zeka özelliklerini kullanmak için kredi harcarsın. Her planda aylık ücretsiz kredi paketi gelir; bunu tükettiğinde ilave kredi satın alabilirsin. Hangi özelliğin ne kadar kredi harcadığını Krediler sayfasında görebilirsin. Harcamaları kontrol altında tutmak için Bütçe sayfasından aylık üst sınır belirleyebilirsin.`)
};

const en_faq_a_kredi_sistemi = /** @type {(inputs: Faq_A_Kredi_SistemiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI features consume credits. Each plan includes a monthly free credit allowance. When you run out you can purchase additional credits. The Credits page shows how many credits each feature uses. Set a monthly cap on the Budget page.`)
};

const de_faq_a_kredi_sistemi = /** @type {(inputs: Faq_A_Kredi_SistemiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Funktionen verbrauchen Credits. Jeder Plan enthält ein monatliches Freikontingent. Wenn du es aufbrauchst, kannst du zusätzliche Credits kaufen. Auf der Credits-Seite siehst du den Verbrauch je Funktion. Ein monatliches Limit legst du auf der Budget-Seite fest.`)
};

const ru_faq_a_kredi_sistemi = /** @type {(inputs: Faq_A_Kredi_SistemiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функции ИИ расходуют кредиты. Каждый тариф включает ежемесячный бесплатный лимит. Когда он заканчивается, можно купить дополнительные кредиты. На странице Кредиты видно, сколько каждая функция расходует. Ежемесячный лимит трат настраивается на странице Бюджет.`)
};

/**
* | output |
* | --- |
* | "AI features consume credits. Each plan includes a monthly free credit allowance. When you run out you can purchase additional credits. The Credits page shows..." |
*
* @param {Faq_A_Kredi_SistemiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_kredi_sistemi = /** @type {((inputs?: Faq_A_Kredi_SistemiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Kredi_SistemiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_kredi_sistemi(inputs)
	if (locale === "de") return de_faq_a_kredi_sistemi(inputs)
	if (locale === "ru") return ru_faq_a_kredi_sistemi(inputs)
	return tr_faq_a_kredi_sistemi(inputs)
});